import { DEFAULT_FORMDATA } from '@/constants/constants.js';
import { CodeCommit } from 'aws-sdk';
export default {
	ADD_LOCATION(state, location) {
		state.parkingLocations = [...state.parkingLocations, location];
	},
	REMOVE_LOCATION(state, index) {
		var newState = [...state.parkingLocations];
		newState.splice(index, 1);
		state.parkingLocations = newState;
	},
	MODIFY_LOCATION(state, { index, newInfo }) {
		var newState = [...state.parkingLocations];
		newState[index] = newInfo;
		state.parkingLocations = newState;
	},
	MODIFY_LOCATION_FIELD(state, { index, field, newInfo }) {
		var newState = [...state.parkingLocations];
		newState[index][field] = newInfo;
		state.parkingLocations = newState;
	},
	UPDATE_PARKING_LOCATIONS_LIST(state) {
		let newRoadList = [];
		let newLotList = [];
		state.parkingLocations.forEach(({ type, ...details }) => {
			if (type == 'street') {
				newRoadList.push(Object.assign({ LocationType: "filming", StreetRoadId: state.roadIdList[details.StreetRoad] }, details));
			}
		});

		state.parkingLocations.forEach(({ type, ...details }) => {
			if (type == 'lot') {
				newLotList.push(Object.assign({ LocationType: "filming" }, details));
			}
		});

		state.formData.SelectedStreetRoadList = newRoadList;
		state.formData.SelectedParkingLocationList = newLotList;
	},
	COMPLETE_STEP(state, { step, complete }) {
		var newState = state.steps;
		newState[step] = complete;
		state.steps = newState;
	},
	UPDATE_FORM_FIELD(state, { field, data }) {
		state.formData[field] = data;
	},
	TOGGLE_DATE(state, { field, data }) {
		state[field] = data;
	},
	UPDATE_LOCATION_TYPES(state, { field, data }) {
		state.locationTypes[field] = data;
	},
	UPDATE_PRIVATE_ADDRESS_FIELD(state, { index, field, data }) {
		let addressList = [...state['Address' + String(index + 1) + 'List'].addressList];
		let addressInfo = Object.assign({}, state.formData.SelectedFilmingLocationList[index]);
		if (field) state.formData.SelectedFilmingLocationList[index][field] = data;

		// Update the key every time the field changes, if there's no match the key will be undefined
		// The field will handle the validation and won't allow progression unless the field is valid
		let match = addressList.find(item => item.number == addressInfo.AddressNumber);
		if (match) state.formData.SelectedFilmingLocationList[index].AddressKey = match['key'];
		/*if (match) 
		{
			state.formData.SelectedFilmingLocationList[index].AddressKey = match['key'];
			state.formData.SelectedFilmingLocationList[index].AddressName = addressInfo.AdressName;
			state.formData.SelectedFilmingLocationList[index].AddressNumber = addressInfo.AdressNumber;
		}*/
	},
	RECOVER_FORMDATA(state, data) {
		
		const { formData: recoveredFormData, steps: recoveredSteps, parkingLocations: recoveredLocations, locationTypes: recoveredTypes, formType: recoveredType, weatherDate: recoveredWeatherDate, prepDate: recoveredPrepDate, wrapDate: recoveredWrapDate, Address1List: recoveredAddress1List, Address2List: recoveredAddress2List, newManager: recoveredNewManager } = data;
		state.formData = Object.assign({}, state.formData, recoveredFormData);
		state.steps = Object.assign({}, state.steps, recoveredSteps);
		state.parkingLocations = [...recoveredLocations];
		state.locationTypes = Object.assign({}, state.locationTypes, recoveredTypes);
		state.step = Object.keys(recoveredSteps).filter(step => {
			return recoveredSteps[step] == false;
		})[0];
		state.formType = recoveredType;
		state.recoveredFormData = true;
		state.recoveredretrievedFormData= true;
		state.weatherDate = recoveredWeatherDate;
		state.prepDate = recoveredPrepDate;
		state.wrapDate = recoveredWrapDate;
		state.newManager = recoveredNewManager;
		state.Address1List = recoveredAddress1List;
		state.Address2List = recoveredAddress2List;
		
	},

	/*BKUP: *****
	RETRIVED_SAVED_FORMDATA(state, data) {
		
	state.formData = Object.assign({}, state.formData, data);
	state.steps = Object.assign({}, state.steps,data.Step);
	state.parkingLocations = [...data.SelectedParkingLocationList, ...data.SelectedStreetRoadList];
	//state.locationTypes = Object.assign({}, data.locationTypes);
	state.formData.CityGrid = data.CityGrid;
	state.newProductionCompany = false;
	state.newManager = false;
	state.FILMINTERIOR = data.FILMINTERIOR;
	state.FILMEXT = data.FILMEXT;
	state.FILMFRONT = data.FILMFRONT;
	state.FILMBACK = data.FILMBACK;
	state.FILMOTHER = data.FILMOTHER;
	state.EQRW = data.EQRW;
	state.EQBLVD = data.EQBLVD;
	state.CAMCAR = data.CAMCAR;
	state.TOWRIG = data.TOWRIG;
	state.VEHPULLUP = data.VEHPULLUP;
	state.VEHPULLLOC = data.VEHPULLLOC;
	state.TRAVSHOOT = data.TRAVSHOOT;
	state.TRAFSTOP = data.TRAFSTOP;
	
	},
	*/
	RETRIEVED_SAVED_FORMDATA(state, data) {
		
		state.formData = Object.assign({}, state.formData, data);
		state.steps = Object.assign({}, state.steps,data.Step);
		//TODO: Comment out the below if need to bring back the parkingLocation values which retrieve from savedAppData's "SelectedStreetRoadList" and "SelectedParkingLocationList"
		let newRoadList = [];
		let newLotList = [];
		if(data.SelectedStreetRoadList.length > 0)
		{
			for(var i=0; i< data.SelectedStreetRoadList.length; i++)
			{
				newRoadList.push(Object.assign({ type: 'street' }, data.SelectedStreetRoadList[i]));
			}
		}
		if(data.SelectedParkingLocationList.length > 0)
		{
			for(var j=0; j< data.SelectedParkingLocationList.length; j++)
			{
				newLotList.push(Object.assign({ type: 'lot' }, data.SelectedParkingLocationList[j]));
			}
		}
		state.parkingLocations = [...newRoadList, ...newLotList];
		

		state.formData.CityGrid = data.CityGrid;
		state.newProductionCompany = false;
		state.newManager = false;
		state.FILMINTERIOR = data.FILMINTERIOR;
		state.FILMEXT = data.FILMEXT;
		state.FILMFRONT = data.FILMFRONT;
		state.FILMBACK = data.FILMBACK;
		state.FILMOTHER = data.FILMOTHER;
		state.EQRW = data.EQRW;
		state.EQBLVD = data.EQBLVD;
		state.CAMCAR = data.CAMCAR;
		state.TOWRIG = data.TOWRIG;
		state.VEHPULLUP = data.VEHPULLUP;
		state.VEHPULLLOC = data.VEHPULLLOC;
		state.TRAVSHOOT = data.TRAVSHOOT;
		state.TRAFSTOP = data.TRAFSTOP;
		
	},


	RESET_FORM(state) {
		state.formData = Object.assign({}, DEFAULT_FORMDATA);
		state.formData.SelectedFilmingLocationList = [
			{
				AddressKey: '',
				AddressName: '',
				AddressNumber: '',
			},
			{
				AddressKey: '',
				AddressName: '',
				AddressNumber: '',
			}
		]
		state.formType = null;
		state.recoveredFormData = false;
		state.locationTypes = { "cityBuilding": false, "cityPark": false, "privateAddress": false, "privateAddress2": false };
		state.parkingLocations = [];
		state.steps = { 1: false, 2: false, 3: false, 4: false, 5: false }
		state.step = 1;
		state.weatherDate = false;
		state.prepDate = false;
		state.wrapDate = false;
		state.newManager = false;
		state.submissionDetails.SubmitSuccess = false;
		state.submissionDetails.Id = null;
		state.intersectionList = [];
		state.formSaveDataList = [];
		state.newProductionCompany = false;
	},
	AUTH_REQUEST(state) {
		state.status = 'loading'
	},
	AUTH_SUCCESS(state, token) {
		state.status = 'success'
		state.token = token
	},
	AUTH_ERROR(state) {
		state.status = 'error'
	},
	USER_LOGIN(state, user) {
		state.user = user;
		state.formData.Id = Number(user.Id);
		state.formData.UserEmail = user.Email;
		state.userLoggedIn = true;
	},
	USER_LOGOUT(state) {
		state.user = {};
		state.formData.Id = null;
		state.userLoggedIn = false;
		state.token = '';
		state.recoveredFormData= false;
	},
	SET_STEP(state, step) {
		state.step = step;
	},
	
	NEXT_STEP(state) {
		state.step++;
	},
	SET_LATEST_COMPLETED_STEP(state) {
		let setStep = Object.keys(state.steps).filter(step => {
			return state.steps[step] == false;
		})[0] || 6;

		if (state.formType === 'grid' && setStep > 3) {
			setStep = 4;
		}

		state.step = setStep;
	},


	
	GET_PRODUCTION_COMPANIES(state, data) {
		const mappedData = data.map(company => {
			let updatedCompany = Object.assign({}, company);
			Object.keys(updatedCompany).forEach(key => {
				if (updatedCompany[key] === "") {
					updatedCompany[key] = 'NO DATA PROVIDED';
				}
			})

			return updatedCompany;
		});
		state.productionCompanies = mappedData;
		state.productionCompanies = mappedData;
	},
	GET_ROAD_LIST(state, roads) {
		state.roadList = roads;
	},
	GET_ROAD_ID_LIST(state, ids) {
		state.roadIdList = ids;
	},
	GET_INTERSECTION_LIST(state, data) {
		state.intersectionList = data;
	},
	GET_ADDRESS_NAME_LIST(state, data) {
		state.addressNameList = data;
	},
	GET_ADDRESS_NUMBERS_LIST(state, { addressList, road, index }) {
		// delete state['Address' + String(index + 1) + 'List'];
		state['Address' + String(index + 1) + 'List'] = { road, addressList };
	},
	GET_FACILITY_LIST(state, { facilities, parks, assetIdList }) {
		state.facilityList = [...facilities];
		state.parkList = [...parks];
		state.assetIdList = assetIdList;
	},
	FORM_SUBMIT_SUCCESS(state, { PermitId }) {
		state.submissionDetails = {
			PermitId, SubmitSuccess: true
		};
	},



//SAVEFORMDATA ON SQL
//FORM_Saved_Display_SUCCESS(state) {
 //state.savedStatusDisplay = true
	//alert (state.savedStatusDisplay + " Mutation ")
	//alert (state.CreatedOn)
//},

	LOADING(state, value) {
		if (value === false) {
			state.loadingMsg = '';
		}

		if (typeof value === 'string') {
			state.loadingMsg = value;
		} else {
			state.loading = value;
		}
	},
	SET_TYPE(state, type) {
		state.formType = type;
		if (type === 'permit') {
			state.formData.CityGrid = "N";
			state.formData.TRVSHOTLOC = "";
			state.formData.TRAVSHOOT = "N";
			state.formData.FILMEXT = "N";
		}

		if (type === 'grid') {
			state.formData.CityGrid = "Y";
			state.formData.TRVSHOTLOC = "CITY ALL";
			state.formData.TRAVSHOOT = "Y";
			state.formData.FILMEXT = "Y";
		}
	},
	TOGGLE_NEW_PROD_COMPANY(state, val) {
		state.newProductionCompany = val;
	},
	TOGGLE_NEW_MANAGER(state, val) {
		state.newManager = val;
	},
	SETSTATE_VALUE: (state, val) => {
		const { name, value, type } = val;
		if( type === "formData") {
			state.formData[name] = value || "";
		}
		else if (type === "locationTypes"){
			state.locationTypes[name] = value;
		}
		else if (type === "ArrayTypes" && value != null){
			state[name] = [...value];
		}
		else if (type === "savedFormData"){
			state.formSavedData[name] = value || "";
		}
		else {
			state[name] = value || "";
		}
	},

	RESETSTATE_VALUE: (state, val) => {
		const { name, value, type } = val;
		switch (type) {
			case "ArrayTypes":
			{
				state[name] =[];
			  	break;
			}	
			case "stepsObj":  
			{
				for(var i=1; i<= 5; i++)
					state.steps[i] = false;
				break;
			}
			default:
			  //console.log("There is no match for ResetState type");
		  }
	},

	SET_SAVEDAPPVALIDATIONLIST: (state, value) =>{
		state.savedAppValidationList.push(value);
	}

}